import service from 'auth/FetchInterceptor'

const sspServices = {}

sspServices.getAdvancedConfidence = async function(data) {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/extra-results/?lang=en`,
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}
sspServices.exportAdvancedConfidenceClient = async function(data) {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/export-extra-results/`,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',  // Important! This tells axios to handle binary response
    data,
    withCredentials: true
  }
  return await service(config)
}
sspServices.exportAdvancedConfidenceAdmin = async function(data) {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/valify/export-extra-results/`,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',  // Important! This tells axios to handle binary response
    data,
    withCredentials: true
  }
  return await service(config)
}
sspServices.getDashboard = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/dashboard-analytics/?lang=en`
      : '/portal-backend/v1/valify/dashboard-analytics/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

sspServices.getUserSessions =async  function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/bundle-sessions/?lang=en`
      : '/portal-backend/v1/valify/bundle-sessions/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

sspServices.getSessionDetails = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/bundle-session-details/?lang=en`
      : '/portal-backend/v1/valify/bundle-session-details/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

sspServices.getUserTransactions = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/bundle-transactions/`
      : '/portal-backend/v1/valify/bundle-transactions/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

sspServices.changePassword = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/accounts/change-password/?lang=en`
      : '/portal-backend/v1/accounts/change-password/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

sspServices.getProfileData = async function (data) {
  const config = {
    method: 'get',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/accounts/profile/?lang=en`
      : '/portal-backend/v1/accounts/profile/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}
sspServices.getClientServices = async function () {
  const config = {
    method: 'get',
    url: process.env.REACT_APP_DOMAIN_NAME
    ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/client-services/?lang=en`
    : '/portal-backend/v1/valify/client-services/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  
  }
  return await service(config)
  }
  
  
  sspServices.getOrganiztionsBundles = async(data) => {
 
    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/organization-bundles/?lang=en`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
      withCredentials: true,
    }
    return await service(config)
  }
sspServices.getBundleServices = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/bundle-services/`
      : '/portal-backend/v1/valify/bundle-services/',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }

  return await service(config)
}

sspServices.getBundleAnalytics = async function (data) {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/valify/bundle-analytics/?lang=en`
      : '/portal-backend/v1/valify/bundle-analytics/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  }
  return await service(config)
}

export default sspServices
